import { HexisSymbol } from './HexisSymbol';

/**
 * O que o Hexis está a fazer AGORA — o mesmo bloco nas duas apps.
 *
 * Porquê isto e não três pontinhos: em CPU, o prefill do modelo leva 15–30 s
 * antes do primeiro token. Três pontinhos durante meio minuto não distinguem
 * «a pensar» de «avariou», e é aí que as pessoas fecham o painel. O servidor
 * já emitia os passos («A consultar a base de conhecimento…», «A redigir a
 * resposta…») e ninguém os mostrava.
 *
 * Duas camadas, deliberadamente:
 *   • o passo ATUAL, sempre visível — é o que responde a «ainda está vivo?»;
 *   • o histórico, atrás de um acordeão fechado — quem quer auditar o
 *     raciocínio abre; quem só quer a resposta não é interrompido por ele.
 */
export function HexisThinking({ steps, done = false }: {
  /** Passos recebidos por ordem de chegada. O último é o atual. */
  steps: string[];
  /** Já há resposta: o passo atual cala-se e fica só o histórico auditável. */
  done?: boolean;
}) {
  const atual = steps[steps.length - 1];
  const temHistorico = steps.length > 1;

  if (steps.length === 0 && !done) {
    // Ainda não chegou passo nenhum (os primeiros ~4 s): a forma de sempre.
    return <span className="chat-typing">A pensar…<i /><i /><i /></span>;
  }
  if (steps.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
      {!done && atual && (
        // aria-live="polite": quem ouve o ecrã acompanha o progresso em vez de
        // esperar em silêncio — mas sem interromper o que estiver a ser lido.
        <span className="chat-typing" role="status" aria-live="polite">
          <span aria-hidden style={{ display: 'inline-flex' }}><HexisSymbol size={13} /></span>
          {atual}<i /><i /><i />
        </span>
      )}
      {temHistorico && (
        <details className="chat-reasoning">
          <summary>Raciocínio · {steps.length} passos</summary>
          {steps.map((s, i) => (
            <div key={`${i}-${s}`} className="step">{s}</div>
          ))}
        </details>
      )}
    </div>
  );
}
